import React, { useState } from 'react';
import { createSolicitation } from '../../services/api';

const PlanoSelectedDetailsStep = ({ plano, onBack, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const hospitais = plano.hospitals || [];

    const hospitalCount = hospitais.filter((h) => h.type.toLowerCase() === 'hospital').length;
    const laboratorioCount = hospitais.filter((h) => h.type.toLowerCase() !== 'hospital').length;

    const itens = hospitais.map((h) => h.name);

    const handleAssinarPlano = async () => {
        if (loading) return;
        setLoading(true);

        const leadId = parseInt(localStorage.getItem("leadId"), 10);
        const planIdInt = Number(plano.id);

        console.log('leadId:', leadId, 'planId:', planIdInt);

        if (!leadId || isNaN(planIdInt)) {
            alert("Lead ou Plano inválido. Por favor, crie um lead e selecione um plano.");
            setLoading(false);
            return;
        }

        const solicitationData = { id_leads: leadId, id_plans: planIdInt };

        try {
            const response = await createSolicitation(solicitationData);
            console.log("Resposta da API =>", response);
            localStorage.clear();
            onSuccess();
        } catch (error) {
            console.error("Erro ao criar solicitação:", error);
            alert("Erro ao criar solicitação. Por favor, tente novamente.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="w-full min-h-screen bg-gray-50 flex flex-col items-center p-6">
            <div className="w-full max-w-3xl flex items-center space-x-4 mb-4">
                <img src="hapivida.webp" alt="Logo do Plano" className="w-[250px] h-auto" />
                <div className="flex-1 flex items-center space-x-2">
                    <h1 className="text-xl font-bold text-gray-600 ml-20">
                        Plano {plano.plan_name}
                    </h1>
                </div>
            </div>

            <hr className="w-full max-w-3xl border-gray-300 mb-6" />

            <div className="w-full max-w-3xl bg-[#7C7C7C14] rounded-lg p-6 shadow-md flex flex-col space-y-4">
                <h2 className="text-lg font-semibold text-gray-800">
                    O que este plano oferece:
                </h2>
                <div className="flex flex-col sm:flex-row justify-between">
                    <ul className="list-none text-sm text-gray-700 space-y-2">
                        {itens.map((item, index) => (
                            <li key={index} className="flex items-center">
                                <span className="text-green-600 text-lg mr-2">✅</span>
                                {item}
                            </li>
                        ))}
                    </ul>

                    <div className="flex flex-col justify-center items-center text-sm text-gray-800 space-y-2">
                        <p className="flex items-center">
                            <span className="text-lg mr-2">🏥</span>
                            {hospitalCount} Hospitais
                        </p>
                        <p className="flex items-center">
                            <span className="text-lg mr-2">🔬</span>
                            {laboratorioCount} Laboratórios
                        </p>

                        <button
                            onClick={handleAssinarPlano}
                            disabled={loading}
                            className={`w-full bg-[#677564] text-white text-[14px] sm:text-[16px] font-poppins font-bold rounded-[7px] transition px-12 py-2 flex justify-center items-center gap-1 
                                ${loading ? "bg-gray-400 cursor-not-allowed" : "hover:bg-[#565b4a]"}`}
                            style={{ marginTop: '30%' }}
                        >
                            {loading ? "Processando..." : "ASSINAR PLANO ❤️"}
                        </button>
                    </div>
                </div>
            </div>

            {onBack && (
                <button onClick={onBack} className="mt-4 bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400 transition">
                    Voltar
                </button>
            )}
        </div>
    );
};

export default PlanoSelectedDetailsStep;
